import React, { useEffect, useState } from 'react';
import { Bookmark } from 'lucide-react';
import api from '../lib/api';
import { LessonCard } from '../components/LessonCard';
import { Spinner } from '../components/ui/Spinner';

export default function Bookmarks() {
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/bookmarks')
      .then(({ data }) => setLessons(data.lessons || []))
      .catch(() => setLessons([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div className="grid h-[60vh] place-items-center">
        <Spinner className="h-8 w-8" />
      </div>
    );

  return (
    <div className="space-y-6" data-testid="bookmarks-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-white">Saved lessons</h1>
        <p className="mt-1 text-sm text-zinc-500">Everything you've bookmarked, in one place.</p>
      </div>

      {lessons.length === 0 ? (
        <div className="grain relative rounded-3xl border border-white/5 bg-ink-card p-16 text-center">
          <Bookmark className="mx-auto text-zinc-600" />
          <p className="mt-3 font-heading text-lg text-white">No bookmarks yet</p>
          <p className="mt-1 text-sm text-zinc-500">Tap “Save” on any lesson to keep it here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {lessons.map((l, i) => (
            <LessonCard key={l.lesson_id} lesson={l} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
